import axios from "axios";
import type { AuthData, GetPopUpsResponse, PopUpFrequency, PopUpType } from "../types/types";
import { attachSentryResponseInterceptor } from "./sentryAxiosInterceptor";

const axiosInstance = axios.create({
  baseURL: import.meta.env.VITE_POPUPS_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

axiosInstance.interceptors.request.use(
  (config) => {
    const localAuth = localStorage.getItem("allaria-auth");
    const parsedLocalAuth: AuthData | null =
      (localAuth && JSON.parse(localAuth)) ?? null;
    const token = parsedLocalAuth?.access_token;
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);
attachSentryResponseInterceptor(axiosInstance);

export const getPopUps = async (params?: {
  type?: PopUpType;
  isPublished?: boolean;
  frequency?: PopUpFrequency;
  page?: number;
  size?: number;
}) => {
  const cleanParams = Object.fromEntries(
    Object.entries(params || {}).filter(
      ([_, v]) => v !== undefined
    )
  );

  const response = await axiosInstance.get("/reports-manager/pop-ups", {
    params: cleanParams,
  });
  return response.data as GetPopUpsResponse;
};

export const dismissPopUp = async (id: number) => {
  await axiosInstance.post(`/reports-manager/pop-ups/${id}/dismiss`);
};
